import { forwardRef } from 'react';
import { Box, BoxProps } from '@nimbus-ds/components';

type AiGeneratedBoxProps = Readonly<{
  aiGenerated?: boolean;
  aiGeneratedProps?: BoxProps;
}> &
  BoxProps;

const AiGeneratedBox = forwardRef<HTMLDivElement, AiGeneratedBoxProps>(
  ({ aiGenerated, children, aiGeneratedProps, ...props }, ref) => (
    <Box
      ref={ref}
      {...(aiGenerated && {
        borderColor: 'transparent',
        background: 'ai-generative-interactive-border',
        borderWidth: '1',
        borderStyle: 'solid',
        borderRadius: '2',
        boxShadow: 'aiFocus',
        ...aiGeneratedProps,
      })}
      {...props}
    >
      {children}
    </Box>
  ),
);

AiGeneratedBox.displayName = 'AiGeneratedBox';

export default AiGeneratedBox;
